const IMAGE_QUERY_PARAMS = "?w=250&auto=format";
const getWishlistItemImage = (item) => {
  return item.imageSrc ? `${item.imageSrc}${IMAGE_QUERY_PARAMS}` : void 0;
};
export {
  getWishlistItemImage
};
//# sourceMappingURL=get-wishlist-item-image.js.map
